import { useHandler } from "@redotech/react-util/hook";
import {
  getMatchTypeLabel,
  ListToListMatchType,
} from "@redotech/redo-flows-core-common/condition";
import { useTranslation } from "@redotech/redo-i18n";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";

export const ListToListMatchTypeSelect = memo(
  function ListToListMatchTypeSelect({
    matchType,
    fieldLabelIsPlural,
    onMatchTypeChange,
    matchTypes,
  }: {
    matchType?: ListToListMatchType;
    fieldLabelIsPlural: boolean;
    onMatchTypeChange: (matchType: ListToListMatchType) => void;
    /** Narrows the offered types; defaults to all of them. */
    matchTypes?: readonly ListToListMatchType[];
  }) {
    const { t } = useTranslation();
    const setMatchType = useHandler(
      ({
        item: matchTypeListItem,
      }: {
        item: RedoListItem<ListToListMatchType>;
      }) => {
        onMatchTypeChange(matchTypeListItem.value);
      },
    );

    const options: RedoListItem<ListToListMatchType>[] = useMemo(() => {
      return (matchTypes ?? Object.values(ListToListMatchType)).map((type) => ({
        value: type,
        type: "text",
        id: type,
        text: getMatchTypeLabel(type, fieldLabelIsPlural),
      }));
    }, [fieldLabelIsPlural, matchTypes]);

    return (
      <RedoSingleSelectDropdownInput<ListToListMatchType>
        fitToAnchor={false}
        flexGrow={false}
        options={options}
        optionSelected={setMatchType}
        placeholder={t("Select a criteria")}
        selectedItem={options.find((o) => o.id === matchType)}
        size="xs"
      />
    );
  },
);
